// extracted by mini-css-extract-plugin
module.exports = {"article":"Home_article__3WKig","footer":"Home_footer__3GE5n","apply":"Home_apply__3QspZ","conditions":"Home_conditions__37rI0"};